import Container from "./VariationPlansListStyle";
import { FaTrashAlt } from "react-icons/fa";

export default function VariationPlans({ planId, variations, history, disabled, onClickDeleteVariation }) {

  function GoToVariation(variationId: number) {
    history.push(`/plans/${planId}/${variationId}`);
  }
  return (
    <Container className="panel">
      <div id="title">
        <h4>Variações da planta</h4>
        <button className="btn btn-success" disabled={disabled} onClick={e => GoToVariation(0)}>Adicionar</button>
      </div>
      <table className="table table-striped table-bordered table-hover main-table" id="productVariationsForm">
        <thead>
          <tr>
            <th scope="col">Nome</th>
            <th scope="col">Cena</th>
            <th scope="col">Deletar</th>
          </tr>
        </thead>
        <tbody>
          {variations && variations.length > 0 && variations.map(variation => {
            return (
              <tr className="clickable" key={variation.id}>
                <td onClick={e => GoToVariation(variation.id)} >{variation.name}</td>
                <td onClick={e => GoToVariation(variation.id)} >{variation.sceneName}</td>
                <td className="action" onClick={() => onClickDeleteVariation(variation)}>
                  <button disabled={disabled}>
                    <FaTrashAlt />
                  </button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </Container >
  )

}